import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const AvatarNameStyled = styled.div`
  .avatar-wrapper {
    display: flex;
    align-items: center;
  }

  .image-bg {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
    margin-right: 12px;
    background-color: ${colors.greyAlpha26};
  }

  .name {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    color: ${tokens.color.text.secondary};
  }
`

export default AvatarNameStyled
